
import React from 'react';
import { ShoppingBag, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Star } from 'lucide-react';

const EcommerceLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: ShoppingBag,
      title: "Loja Online",
      subtitle: "Explore nossos produtos",
      url: "https://decidedigital.com.br/",
      color: "bg-emerald-500 hover:bg-emerald-600"
    },
    {
      icon: MessageCircle,
      title: "Atendimento WhatsApp",
      subtitle: "Suporte instantâneo",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20as%20solu%C3%A7%C3%B5es%20da%20Decide%20Digital!",
      color: "bg-green-500 hover:bg-green-600"
    },
    {
      icon: Phone,
      title: "Central de Vendas",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      color: "bg-blue-500 hover:bg-blue-600"
    },
    {
      icon: Mail,
      title: "Contato Comercial",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      color: "bg-purple-500 hover:bg-purple-600"
    },
    {
      icon: MapPin,
      title: "Localização da Loja",
      subtitle: "Visite nossa unidade",
      url: "https://maps.app.goo.gl/67vmppvo3ERddDZQ9",
      color: "bg-red-500 hover:bg-red-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-3xl p-6 shadow-xl mb-6 animate-fade-in">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-emerald-400 to-blue-500 rounded-full flex items-center justify-center">
              <ShoppingBag className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Decide Digital Store</h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              Sua loja digital de confiança. Oferecemos soluções completas para seu negócio 
              crescer no mundo digital com qualidade e suporte especializado.
            </p>
            
            <div className="flex items-center justify-center mt-3">
              <div className="flex text-yellow-400">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <span className="text-gray-600 text-sm ml-2">4.9 (127 avaliações)</span>
            </div>
          </div>
        </div>

        <div className="flex justify-center space-x-3 mb-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md hover:shadow-lg link-button animate-scale-in animate-delay-${index * 100}`}
            >
              <social.icon className="w-5 h-5 text-gray-700" />
            </a>
          ))}
        </div>

        <div className="space-y-3">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-4 ${link.color} rounded-2xl text-white shadow-lg link-button animate-fade-in animate-delay-${index * 100}`}
            >
              <div className="flex items-center">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                  <link.icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="bg-gradient-to-r from-orange-400 to-pink-500 rounded-2xl p-4 mt-6 text-white text-center animate-fade-in">
          <p className="font-semibold">🔥 Oferta Especial</p>
          <p className="text-sm">Entre em contato e ganhe 10% de desconto!</p>
        </div>
      </div>
    </div>
  );
};

export default EcommerceLinktree;
